import { Inject, Injectable } from '@angular/core';
import { ApigeeDAO } from './apigee.dao';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { Observable } from 'rxjs/Observable';
import { APP_CONFIG } from '../config';
import { ReservationDataValidator } from './validators/data.validators';
import { DefaultRetryHandler } from './handlers/retry.handlers';
import { HttpClient } from '@angular/common/http';
import { LogService } from '../services/logging.service';
import { IHotelReservation } from '../interfaces/HotelReservation/IHotelReservation';
import { CookieService } from 'ngx-cookie-service';

const CLASS_NAME = 'ReservationDao';

@Injectable()
export class ReservationDao extends ApigeeDAO {
  constructor(http: HttpClient, @Inject(APP_CONFIG) appConfig: IAppConfig, log: LogService, cookieService: CookieService) {
    super(CLASS_NAME, http, appConfig, appConfig.hotelReservationDAO, new DefaultRetryHandler(), new ReservationDataValidator(), log, cookieService);
  }

  get(reservationId: string, lastName: string): Observable<any> {
    const url = `${this.daoConfig.url}/${reservationId}`;
    return super.doGet(url, { lastName: lastName });
  }

  put(reservationData: IHotelReservation): Observable<any> {
    const url = this.daoConfig.url;
    return super.doPut(url, reservationData, { 'IHG-SellSource': this.getSellSource() });
  }

  delete(reservationId: string, lastName: string): Observable<any> {
    const url = `${this.daoConfig.url}/${reservationId}?lastName=${lastName}`;
    return super.doDelete(url, { 'IHG-SellSource': this.getSellSource() });
  }

  private getSellSource(): string {
    let edwSellSource = 'WEBWB';
    if (this.cookieService.check('akamaiIsTablet') && this.cookieService.get('akamaiIsTablet') === 'true') {
      edwSellSource = 'WEBTB';
    }
    if (this.cookieService.check('akamaiIsWirelessDevice') && this.cookieService.get('akamaiIsWirelessDevice') === 'true') {
      edwSellSource = 'WEBMW';
    }
    return edwSellSource;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/reservation.dao.ts